import {showErrorToast, showSuccessToast} from './Toast';
import axios from 'axios';
import {handleErrorResponse} from './errorHandler';
import {ref} from 'vue';

export default function useFileHandler(props, onUploadSuccess, onUploadProgress = null, fileType = null, customAction = null) {
    const uploadPercentage = ref(0);
    const isValidFileExtension = (filename) => {
        let allowedExtensions = /(\.jpg|\.jpeg|\.png|\.gif|\.svg)$/i;
        if(fileType !== null) {
            switch (fileType) {
                case 'pdf':
                    allowedExtensions = /(\.pdf)$/i;
                    break;
                case 'doc':
                    allowedExtensions = /(\.docx?)$/i;
                    break;
                case 'xlsx':
                    allowedExtensions = /(\.xlsx?)$/i;
                    break;
                case 'ppt':
                    allowedExtensions = /(\.pptx?)$/i;
                    break;
            }
        }
        return allowedExtensions.exec(filename);
    };

    const uploadFile = async (file, source, type = null) => {

        try {
            //Send a POST request to the server
            const formData = new FormData();
            let fileName = 'image';
            if(fileType !== null) {
                switch (fileType) {
                    case 'xlsx':
                    case 'pdf':
                    case 'doc':
                    case 'ppt':
                        fileName = 'media';
                        break;
                }
            }
            formData.append(fileName, file);
            const response = await axios.post(props.routeUpload, formData, {
                headers: {
                    'X-CSRF-TOKEN': props.csrf // Include CSRF token here
                },
                onUploadProgress: (progressEvent) => {
                    uploadPercentage.value = parseInt(Math.round((progressEvent.loaded / progressEvent.total) * 100));
                    if (onUploadProgress) {
                        onUploadProgress(uploadPercentage.value, source, type); // Call the callback with the current
                        // upload
                        // progress
                    }
                },
            });
            //Handle response here
            if(response.status === 200) {
                const data = response.data;
                if(data.success === 1) {
                    // Call the callback function with the response
                    if (onUploadSuccess && typeof onUploadSuccess === 'function') {
                        onUploadSuccess(data, source, type);
                    }
                    uploadPercentage.value = 0; // Reset after upload

                } else {
                    showErrorToast(data.message);
                }
            } else {
                if(response.message) {
                    showErrorToast(response.message);
                }
            }

        } catch (error) {
            showErrorToast(handleErrorResponse(error));
            console.error('Submission error', error);
        }
    };

    const handleFileUpload = (event, source, type = null) => {
        const file = event.target.files[0];
        if(!file) {
            return false;
        }
        if(!isValidFileExtension(file.name)) {
            showErrorToast('Invalid file extension');
            return false;
        }

        uploadFile(file, source, type);
    };

    const handleFileUploadPDF = (event, source = 'pc', type = null) => {
        const file = event.target.files[0];
        if(!file) {
            return false;
        }
        if(!isValidFileExtension(file.name)) {
            showErrorToast('Invalid file extension');
            return false;
        }

        uploadFile(file, source, type);
    };

    if(fileType !== null) {
        return {
            handleFileUploadPDF,
        }
    }
    return {
        handleFileUpload,
    }

}
